import React from "react";
import styled from "styled-components";
import Button from "../../components/styled/Button";
import { Headline, Paragraph, PreText } from "../../components/styled/Text";
import { Link } from "react-router-dom";
import { Row } from "../../components/styled/Flex";

const HeroSection = styled.div`
  display: flex;
  max-width: 680px;
  justify-content: center;
  flex-direction: column;
  margin: 20px 0;
  @media screen and (max-width: 768px) {
    padding-left: 24px;
    padding-right: 24px;
  }
`;

const HomeWrapper = styled.div`
  width: 100%;
  justify-content: center;
  display: flex;
`;

const Home = () => {
  return (
    <HomeWrapper>
      <HeroSection>
        <PreText>TOKEN RELAUNCH TOOLKIT</PreText>
        <Headline textAlign="center">
          Relaunch your tokens with Lossless Security
        </Headline>
        <Paragraph textAlign="center" marginBottom="90px" marginTop="10px">
          With a few simple clicks, you can now relaunch your existing projects
          token with added Lossless security completely free of charge. It's
          100% free.
        </Paragraph>
        <Row gap={"25px"}>
          <a
            href="https://lossless.cash"
            style={{ textDecoration: "none" }}
            rel="noreferrer"
            target="_blank"
          >
            <Button>Visit Lossless</Button>
          </a>
          <Link to="/token-submit" style={{ textDecoration: "none" }}>
            <Button>Launch App</Button>
          </Link>
        </Row>
      </HeroSection>
    </HomeWrapper>
  );
};

export default Home;
